.m-spinner {
  vertical-align: middle;
}

.m-spinner-mat {
  animation: m-spin 2s linear infinite;
  transform-origin: center center;

  .path {
    /* ENG-20847 no base stroke-dasharray — SVG default is solid stroke, visible when animation is disabled (e.g. Chromatic) */
    animation: m-mat-dash 1.5s ease-in-out infinite;
  }
}

@keyframes m-spin {
  0% {
    transform: rotate3d(0, 0, 1, 0deg);
  }
  25% {
    transform: rotate3d(0, 0, 1, 90deg);
  }
  50% {
    transform: rotate3d(0, 0, 1, 180deg);
  }
  75% {
    transform: rotate3d(0, 0, 1, 270deg);
  }
  100% {
    transform: rotate3d(0, 0, 1, 359deg);
  }
}

@keyframes m-mat-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}
